let Countdown = {};

Countdown.getClientsEndTimeInMsSinceEpoch = function (endTimeInMsSinceEpoch, serverTimeInMsSinceEpoch, networkDelay) {
    let clientTimeInMsSinceEpoch = new Date().getTime();
    let clientOffsetInMs = clientTimeInMsSinceEpoch - (serverTimeInMsSinceEpoch + networkDelay);

    return endTimeInMsSinceEpoch + clientOffsetInMs;
};

Countdown.formatRemainingTime = function (remainingSeconds) {
    let timeLeft = Countdown.createRemainingTimeObject(remainingSeconds);

    if (remainingSeconds < 60) {
        return timeLeft.seconds + ' sek';
    }

    if (remainingSeconds < 3600) {
        return timeLeft.minutes + ' min ' + timeLeft.seconds + ' sek';
    }

    return timeLeft.hours + ' tim ' + timeLeft.minutes + ' min';
};

Countdown.createRemainingTimeObject = function (remainingSeconds) {
    if (remainingSeconds < 60) {
        return { hours: 0, minutes: 0, seconds: remainingSeconds };
    }

    let secondsLeft = remainingSeconds;
    let s = secondsLeft % 60;
    let minutesLeft = (secondsLeft - s) / 60;
    let m = minutesLeft % 60;
    let hoursLeft = (minutesLeft - m) / 60;
    let h = hoursLeft % 24;

    return { hours: h, minutes: m, seconds: s };
};


module.exports = Countdown;


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/models/countdown.js